export default __webpack_public_path__ + "static/media/logo.36d4c8a5.png";